import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusCriticalIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path d="m1 1 10 10H1V1Z" />
    </Icon>
  )
);
export default StatusCriticalIcon;
